import React, { Fragment, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    changeAffiliate,
    updateCurrentStockBalances,
} from '../ActionsBevego/Affiliates.action';
import { load } from '../ActionsBevego/Cart.action';
import Button from './Button';
import ArrowRight2 from '@Icons/arrow-right2.svg';
import { translate } from '../Services/translation';

const AffiliatePicker = () => {
    const dispatch = useDispatch();
    const affiliates = useSelector((state) => state.affiliates);
    const [showInfo, setShowInfo] = useState(false);
    const [newAffiliateName, setNewAffiliateName] = useState(null);
    const [selectedAffiliate, setSelectedAffiliate] = useState(null);
    const [selectedAffiliateName, setSelectedAffiliateName] = useState(null);

    const handleChange = (selectedAffiliate) => {
        dispatch(changeAffiliate(selectedAffiliate));
        setNewAffiliateName(selectedAffiliateName);
        affiliatePickerModal.close();

        let articlesToFetch = [];
        var stockBalances = document.querySelectorAll('[data-stockvariantid]');
        stockBalances.forEach((element) => {
            articlesToFetch.push(element.dataset.stockvariantid);
        });
        if (articlesToFetch.length > 0) {
            dispatch(
                updateCurrentStockBalances(selectedAffiliate, articlesToFetch)
            );
        }
        if (document.getElementById('checkout')) {
            setTimeout(() => {
                dispatch(load());
            }, 200);
        }
    };

    const onOptionClicked = (option) => {
        setSelectedAffiliate(option.value);
        setSelectedAffiliateName(option.selectedOptions[0].label);
    };

    return (
        <Fragment>
            <div>
                <a className="affiliate-picker__btn-open-modal" onClick={() => affiliatePickerModal.showModal()}>
                    <span className='choosed-label'>{translate('code.affiliatepage.choosed.label')}</span>
                    <span>{newAffiliateName || affiliates[0].name}</span>
                    <ArrowRight2 />
                </a>
                <dialog id="affiliatePickerModal" className="custom-modal">
                    <form method="dialog">
                        <div className="custom-modal__container">
                            <a
                                onClick={() => affiliatePickerModal.close()}
                                className="custom-modal__close"
                            >
                                <i className="fa fa-circle-xmark"></i>
                            </a>
                            {showInfo ? (
                                <div className="custom-modal__info">
                                    <h4 className="custom-modal__header">
                                        {translate(
                                            'code.info.header.changeaffiliate'
                                        )}
                                    </h4>
                                    <div className="custom-modal__info-text">
                                        {translate(
                                            'code.info.text.changeaffiliate'
                                        )}
                                    </div>
                                    <Button
                                        onClick={() => setShowInfo(!showInfo)}
                                        outlined="true"
                                        title={translate(
                                            'code.info.button.changeaffiliate'
                                        )}
                                    />
                                </div>
                            ) : (
                                <Fragment>
                                    <h4 className="custom-modal__header">
                                        {translate(
                                            'code.affiliate.header.changeaffiliate'
                                        )}
                                    </h4>
                                    <div className="form__select-wrapper">
                                        <select
                                            className="form__select affiliate-picker__form-select"
                                            value={selectedAffiliate || ''}
                                            onChange={(e) =>
                                                onOptionClicked(e.target)
                                            }
                                        >
                                            {affiliates &&
                                                affiliates.map((affiliate) => (
                                                    <option
                                                        value={affiliate.id}
                                                        key={`affiliate-${affiliate.id}`}
                                                    >
                                                        {affiliate.name}
                                                    </option>
                                                ))}
                                        </select>
                                    </div>
                                    <Button
                                        onClick={() =>
                                            handleChange(selectedAffiliate)
                                        }
                                        cssClass="custom-modal__button"
                                        outlined="true"
                                        title={translate(
                                            'code.affiliate.button.changeaffiliate'
                                        )}
                                    />
                                    <div className="custom-modal-info-link-container">
                                        <a
                                            className="custom-modal-info-link"
                                            onClick={() =>
                                                setShowInfo(!showInfo)
                                            }
                                        >
                                            {translate(
                                                'code.info.link.changeaffiliate'
                                            )}
                                        </a>
                                    </div>
                                </Fragment>
                            )}
                        </div>
                    </form>
                </dialog>
            </div>
        </Fragment>
    );
};
export default AffiliatePicker;
